<div class="container bg-white p-2">
  <div class="row">
    <div class="col-12">
      <h1 class="text-center"></h1>
    </div>
  </div>
  <!--<div class="col-12 mt-2">
      <div class="row tipologie">
          <div class="col-6"><h4 class="text-center text-primary">STORIA</h4>
              <hr></div>
          <div class="col-6"><h4 class="text-center text-tertiary">ARTE</h4>
              <hr></div>
      </div>
  </div>-->
  <div class="timeline">
    <div class=" anno" *ngFor="let anno of interaction.timeline">

      <div class="col-12">
        <div class="anno text-center"><h2 class="text-secondary">{{anno.anno}}</h2></div>
        <div class="row">
          <div class="col-6 element sx text-right">
                    <span *ngFor="let event of anno.storia">
                        <p class="mb-2" [innerHTML]="event"></p>
                    </span></div>
          <div class="col-6 element dx">
                    <span *ngFor="let event of anno.arte">
                        <p class="mb-2" [innerHTML]="event"></p>
                    </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-5">
    <div class="col-12">
      <h4 class="text-center mb-4" *ngIf="language === 'it'">Salendo in cima al campanile potrete ammirare il centro storico da una nuova prospettiva e trovare la linea del tempo di Roccavione</h4>
      <h4 class="text-center mb-4" *ngIf="language === 'en'">Climbing to the top of the bell tower you can admire the historic center from a new perspective and find the Roccavione timeline! But if you don't know how to go up, you can also discover this timeline from below!
      </h4>
      <h4 class="text-center mb-4" *ngIf="language === 'fr'">Salendo in cima al campanile potrete ammirare il centro storico da una nuova prospettiva e trovare la linea del tempo di Roccavione</h4>
      <img src="assets/images/timeline/campanile_roccavione.jpg" alt="" class="img-fluid">

    </div>
  </div>
</div>
